import { apolloClient } from "@/plugins/apollo";
import { gql } from "@apollo/client/core";
import { MasterCountryFragment } from "@composables/masterdata/countries";
import { MasterBreedFragment } from "@/composables/masterdata/breeds";

export default function (id, type) {
  switch (type) {
    case "Country":
      return apolloClient.readFragment({
        id: "Country:" + id,
        fragment: gql`
          fragment GetCountry on Country {
            ${MasterCountryFragment}
          }
        `,
        fragmentName: "GetCountry"
      });
    case "Breed":
      return apolloClient.readFragment({
        id: "Breed:" + id,
        fragment: gql`
          fragment GetBreed on Breed {
            ${MasterBreedFragment}
          }
        `,
        fragmentName: "GetBreed"
      });
  }
}
